// src/contexts/ScrollPositionContext.tsx
import React, { createContext, useState, useContext, ReactNode } from 'react';

interface ScrollPositionContextType {
    positions: { [key: string]: number };
    setPosition: (path: string, position: number) => void;
}

const ScrollPositionContext = createContext<ScrollPositionContextType | undefined>(undefined);

export const ScrollPositionProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [positions, setPositions] = useState<{ [key: string]: number }>({});

    const setPosition = (path: string, position: number) => {
        setPositions((prev) => ({ ...prev, [path]: position }));
    };

    return (
        <ScrollPositionContext.Provider value={{ positions, setPosition }}>
            {children}
        </ScrollPositionContext.Provider>
    );
};

export const useScrollPosition = () => {
    const context = useContext(ScrollPositionContext);
    if (!context) {
        throw new Error('useScrollPosition must be used within a ScrollPositionProvider');
    }
    return context;
};
